<template>
  <div class="contenedor-difusion">
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Examen Cargado</h1>
        <div class="barra"></div>
        <section class="contenedor-inscripciones">
          <div class="contenedor_datos_inscripcion_examen">
            <router-link :to="`/mesa-examen-noviembre-2025`" class="boton_volver_login"><span>&#8592;</span> Atrás</router-link>
            <div class="contenedor_datos_examen_box">
              <div class="postulante_examen_img">
                <img v-if="datos.imagen_perfil != null" :src="imagenPerfilRuta" :alt="`${datos.nombre} ${datos.apellido}`">
                <img v-else src="@/assets/image-not-available.jpg" :alt="`${datos.nombre}`">
                <h2>{{datos.nombre}} {{datos.apellido}}</h2>
              </div>
              <p><b>Fecha:</b> {{ fecha(datos.fecha_examen) }}</p>
              <p><b>Certificación:</b> {{ datos.certificacion.nombre }}</p>
              <p><b>Calificación:</b> {{ datos.resultado.nombre }}</p>
              <p><b>Evaluador Oficial #1:</b> <span v-if="datos.evaluador_oficial1 != null">{{ datos.evaluador_oficial1.nombre }} {{ datos.evaluador_oficial1.apellido }}</span> </p>
              <p><b>Evaluador Oficial #2:</b> <span v-if="datos.evaluador_oficial2 != null">{{ datos.evaluador_oficial2.nombre }} {{ datos.evaluador_oficial2.apellido }}</span></p>
              <p><b>Evaluador Oficial #3:</b> <span v-if="datos.evaluador_oficial3 != null">{{ datos.evaluador_oficial3.nombre }} {{ datos.evaluador_oficial3.apellido }}</span></p>
              <p><b>Evaluador Entrenamiento:</b> <span v-if="datos.evaluador_entrenamiento != null">{{ datos.evaluador_entrenamiento.nombre }} {{ datos.evaluador_entrenamiento.apellido }}</span></p>
              <p><b>Evaluador Moderador:</b> <span v-if="datos.evaluador_moderador != null">{{ datos.evaluador_moderador.nombre }} {{ datos.evaluador_moderador.apellido }}</span></p>
              <p><b>Comentario:</b> <span v-if="datos.comentario != null">{{ datos.comentario }}</span></p>
            </div>
            <div class="contenedor_files_examen_cargado">
              <div class="file_examen_cargado" v-if="mostrarPlanillaDePuntaje">
                <p>Planilla de Puntaje</p>
                <a :href="imagenRuta(`${this.datos.planilla_puntaje}`)" target="_blank"><img :src="imagenRuta(`${this.datos.planilla_puntaje}`)" alt="Planilla de puntaje"></a>
              </div>
              <div class="file_examen_cargado" v-if="mostrarCartaDevolucion">
                <p>Carta de Devolución</p>
                <a :href="imagenRuta(`${this.datos.carta_devolucion}`)" target="_blank"><img :src="imagenRuta(`${this.datos.carta_devolucion}`)" alt="Carta de devolución"></a>
              </div>
            </div>
            <router-link :to="`/editar-examen/${datos.evaluacion_id}`"  class="boton_editar_examen boton_mesa_examen_estilo boton_ver_info">Editar Examen</router-link>
          </div>
        </section>
      </div>
      <section class="contenedor-login">
      </section>
    </section>
  </div>
</template>
<script>
import store from './../store'
import examenService from '../services/examen'
import { PATH_IMG } from '../constants'
export default {
  name: 'DatosInscripcionExamen',
  components: {
  },
  data: function () {
    return {
      store,
      datos: null,
      mostrarBotonCargarExamen: true,
      mostrarMensajeExamenCargado: false,
      mostrarPlanillaDePuntaje: false,
      mostrarCartaDevolucion: false
    }
  },
  methods: {
    fecha (fecha) {
      const year = fecha.slice(0, 4)
      const month = fecha.slice(5, 7)
      const day = fecha.slice(8, 10)
      return day + '/' + month + '/' + year
    },
    imagenRuta: function (x) {
      // console.log(x)
      return `${PATH_IMG}/examen/${x}`
      // return `${PATH_IMG}/examen/${this.datos.planilla_puntaje}`
    }
  },
  computed: {
    imagenPerfilRuta: function () {
      return `${PATH_IMG}/${this.datos.imagen_perfil}`
    }
  },
  mounted: function () {
    examenService
      .traerDatosExamenCargado(this.$route.params.id)
      .then(respuesta => {
        // this.cargando = false
        console.log('Datos: ', respuesta[0])
        this.datos = respuesta[0]
        if (this.datos.planilla_puntaje == null) {
          this.mostrarPlanillaDePuntaje = false
        } else {
          this.mostrarPlanillaDePuntaje = true
        }
        if (this.datos.carta_devolucion == null) {
          this.mostrarCartaDevolucion = false
        } else {
          this.mostrarCartaDevolucion = true
        }
      })
    examenService
      .checkCargaDeExamen(this.$route.params.id)
      .then(respuesta => {
        console.log(respuesta)
        if (respuesta.success) {
          this.mostrarBotonCargarExamen = false
          this.mostrarMensajeExamenCargado = true
        }
      })
  }
}
</script>
<style>

</style>
